export const FETCH_PARTNERS_PENDING = 'FETCH_PARTNERS_PENDING';
export const FETCH_PARTNERS_SUCCESS = 'FETCH_PARTNERS_SUCCESS';
export const FETCH_PARTNERS_FAILED = 'FETCH_PARTNERS_FAILED';
